import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/* @ts-expect-error - TODO: Fix this the next time the file is edited. */
export const withParamsAndNavigate = (Component) => (props) => {
  const params = useParams();
  const navigate = useNavigate();
  return <Component {...props} params={params} navigate={navigate} />;
};
